import { render, staticRenderFns } from "./AnalystRatingFund.vue?vue&type=template&id=37178f10&"
import script from "./AnalystRatingFund.vue?vue&type=script&lang=js&"
export * from "./AnalystRatingFund.vue?vue&type=script&lang=js&"
import style0 from "./AnalystRatingFund.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-analyst-rating/src/components/analystRating/AnalystRatingFund.vue"
export default component.exports